import { memo } from "react";

import "../styles/loading.css";

type Props = {
  done?: boolean;
  className?: string;
};
const Spinner = (props: Props) => {
  return (
    <span
      className={`spinner ${props.done ? "done" : ""} ${props.className}`}
    ></span>
  );
};

const SpinnerMemo = memo(Spinner);

export { SpinnerMemo as Spinner };
